import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import 'app/viewport/components/NotificationBadge.scss';

const bem = bemify('notification-badge');

const NotificationBadge = createReactClass({
  displayName: 'NotificationBadge',

  propTypes: {
    kind: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      kind: 'new',
    };
  },

  render() {
    const { kind } = this.props;
    const label = kind.replace(/-/g, ' ');
    return <div className={bem(toModifiers(kind))}>{label}</div>;
  },
});

export default NotificationBadge;
